<template>
    <div>
        <router-view :key="$route.fullPath" />
        <loading />
        <alert />
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import alert from './components/common/Alert.vue';
import loading from './components/common/Loading.vue';
import { LANGUAGE } from './const';
import { exitDialog } from './helper/DialogHelper';
import MobileHelper from './helper/MobileHelper';
export default {
    name: 'App',
    components: { loading, alert },
    data: () => {
        return {
            bodyCls: ''
        };
    },
    computed: {
        ...mapState({
            network: state => state.device.network,
            screen: state => state.device.screen
        })
    },
    watch: {
        $route: 'fetchData'
    },
    created() {
        this.uiInit();
    },
    mounted() {
        /* 추가되어야 할 API */
        //PC에서의 개발편의를 위해서 웹뷰인 경우만 corova.js를 load 하도록 처리함
        this.$i18n.locale = localStorage.getItem(LANGUAGE) || 'ko';
        //document.addEventListener('backbutton', this.backbtn, false);
        console.log(MobileHelper.isWebView());
        if (MobileHelper.isWebView()) {
            const platform = MobileHelper.getPlatform();
            console.log();
            if (platform) {
                var script = document.createElement('script');
                script.onload = () => {
                    document.addEventListener('deviceready', this.onDeviceReady.bind(this), false);
                };
                script.onerror = () => {
                    console.error('script load error');
                };
                console.log(process.env);
                //script.src = CORDOVA_SRC;
                script.src = process.env.CORDOVA_DOMAIN;
                document.head.appendChild(script);
            }
        }

        this.init3D();
    },
    destroyed() {},
    methods: {
        ...mapActions(['setNetworkState', 'setScreenOrientation', 'showLoading', 'hideLoading']),
        backbtn() {
            exitDialog();
        },
        doLastAccess() {
            MobileHelper.doLastAccess();
        },
        onDeviceReady() {
            //const platform = MobileHelper.getPlatform();
            //if (platform !== 'ios') this.syncCodePush();
            //ScreenHelper.setLandscape();
        },
        orientationChange() {
            this.setScreenOrientation(window.screen.orientation.type);
        },
        networkOnline() {
            this.setNetworkState(navigator.connection.type);
        },
        networkOffline() {
            this.setNetworkState(navigator.connection.type);
        },
        fetchData() {
            this.showLoading();
            this.uiInit();
        },
        uiInit() {
            if (this.$route.meta.bodyClass) {
                document.body.classList = this.$route.meta.bodyClass;
            }
        },
        init3D() {
            var buildUrl = '/3d';
            var loaderUrl = buildUrl + '/juwangDam_V2.loader.js';

            var script = document.createElement('script');
            script.src = loaderUrl;
            script.onload = () => {
                console.log('loaded unity');
            };
            document.body.appendChild(script);
        }
    }
};
</script>
